import MessageDialog from '../layout/MessageDialog.vue';

const MessageDialogPlugin = {
  install(Vue) {
    // 创建一个 Vue 实例来挂载弹窗组件
    const MessageDialogConstructor = Vue.extend(MessageDialog);
    const instance = new MessageDialogConstructor().$mount(document.createElement('div'));
    document.body.appendChild(instance.$el);

    const isEnglish = () => (localStorage.getItem('language') || '').toLowerCase() === 'en';
    const translate = (text) => {
      if (!isEnglish() || text === null || text === undefined) return text;
      const value = String(text);
      const exact = {
        '提示': 'Info',
        '确认': 'Confirm',
        '确定': 'OK',
        '取消': 'Cancel',
        '成功': 'Success',
        '错误': 'Error',
        '账户切换': 'Account Switched',
        '网络切换': 'Network Switched',
        '已复制': 'Copied',
        '复制成功': 'Copied successfully',
        '请先连接钱包': 'Please connect your wallet first.',
        '请先安装钱包': 'Please install or open your wallet first.',
        '请先完成钱包签名登录': 'Please complete wallet signature login first.',
        '钱包已断开连接。': 'Wallet has been disconnected.',
        '请输入支付密码': 'Please enter your transaction password.',
        '支付密码错误': 'Incorrect transaction password.',
        '请输入闪兑金额': 'Please enter the exchange amount.',
        '请先连接系统绑定钱包': 'Please connect your bound wallet first.',
        '请输入好友账号和数量': 'Please enter your friend account and amount.',
        '请输入好友地址或UID': 'Please enter your friend address or UID.',
        '请选择提现地址': 'Please select a withdrawal address.',
        '请切换到BSC网络后再充值': 'Please switch to BSC network before depositing.',
        '链上确认数不足，不能入账': 'Insufficient on-chain confirmations. Cannot credit yet.',
        '充值未完成链上确认，不能入账': 'Deposit has not completed on-chain confirmation yet.',
        '绑定成功': 'Bound successfully.',
        '绑定失败': 'Binding failed.',
        '网络错误，绑定失败': 'Network error. Binding failed.'
      };
      if (exact[value]) return exact[value];
      const rules = [
        [/钱包账户已切换到[:：]\s*(.*)/, 'Wallet account switched to: $1'],
        [/网络已切换到 Chain ID[:：]\s*(.*)/, 'Network switched to Chain ID: $1'],
        [/余额不足|账户余额不足/i, 'Insufficient balance.'],
        [/用户不存在|账户不存在/i, 'Account does not exist. Please reconnect your wallet.'],
        [/钱包地址不正确|地址不正确/i, 'Wallet address is invalid. Please reconnect your wallet.'],
        [/签名验证失败|钱包签名验证失败/i, 'Wallet signature verification failed.'],
        [/签名登录失败|钱包签名登录失败/i, 'Wallet signature login failed.'],
        [/资产包不存在|已下架|套餐不存在/i, 'Asset package does not exist or has been removed.'],
        [/请输入正确的链上交易Hash/i, 'Please enter a valid on-chain transaction hash.'],
        [/该交易Hash已提交，请勿重复提交/i, 'This transaction hash has already been submitted.'],
        [/网络|服务器/i, 'Network or server error. Please try again.']
      ];
      const found = rules.find(([pattern]) => pattern.test(value));
      return found ? value.replace(found[0], found[1]) : value;
    };

    // 挂载到 Vue 原型上
    Vue.prototype.$messageDialog = {
      show(options = {}) {
        options.title = translate(options.title || '提示');
        options.message = translate(options.message || '');
        options.confirmButtonText = translate(options.confirmButtonText || '确定');
        options.cancelButtonText = translate(options.cancelButtonText || '取消');
        // 设置弹窗的 props
        for (const key in options) {
          if (Object.prototype.hasOwnProperty.call(options, key)) {
            instance[key] = options[key];
          }
        }
        // 调用组件的 show 方法并返回 Promise
        return instance.show();
      },
      // 快捷方法
      alert(message, title = '提示', type = 'info') {
        return this.show({ message, title, type, showCancelButton: false });
      },
      confirm(message, title = '确认', type = 'warning') {
        return this.show({ message, title, type, showCancelButton: true });
      }
    };
  }
};

export default MessageDialogPlugin;
